.pc-wrapper {
  all: initial;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #80808080;
  opacity: 0;
  visibility: hidden;
  transform: scale(1.1);
  transition:
    visibility 0s linear 0.25s,
    opacity 0.25s 0s,
    transform 0.25s;
  z-index: 1;
}

.visible {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  transition:
    visibility 0s linear 0s,
    opacity 0.25s 0s,
    transform 0.25s;
}

.modal {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  max-height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 24px;
  border-radius: 8px 8px 0px 0px;
  overflow-x: hidden;

  &.applyOnly {
    background-color: #f5f5f7;
  }
}

.lowes-filler-div {
  margin-top: 500px;
}

@media only screen and (min-width: 641px) {
  .modal {
    position: absolute;
    width: 35vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 2px;
    min-width: 350px;
    max-width: 500px;
    max-height: min(816px, 100vh);
  }
}

@media only screen and (max-width: 640px) {
  .modal {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 24px;

    &.lowesMode {
      bottom: unset;
    }
  }
}
